module.exports = __webpack_public_path__ + "img/DJI_0569.ba84520c.gif";